import axios from "axios";
import { prop } from "ramda";
import {environmentVariables} from "../../accounts/environmentVariables";

const handleError = err => {
    return Promise.reject(err.response);
};

const dataProp = prop("data");

const httpClient = token => {
    const instance = axios.create();

    if (token) {
        instance.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    return instance;
};

export const apiUrl = environmentVariables.VUE_APP_API_VERSION;

export const get = (url, token) =>
    httpClient(token)
        .get(url)
        .then(dataProp)
        .catch(handleError);

export const post = (url, payload, token) =>
    httpClient(token)
        .post(url, payload)
        .then(dataProp)
        .catch(handleError);

export const put = (url, payload, token) =>
    httpClient(token)
        .put(url, payload)
        .then(dataProp)
        .catch(handleError);

export const Delete = (url, token) =>
    httpClient(token)
        .delete(url)
        .then(dataProp)
        .catch(handleError);
